import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Redirect from "./Redirect";

function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/:uniqueCode" element={<Redirect />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
